import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Route from './Route';
import { currentUserSelector } from '../../../reducers/selectors'

import get from 'lodash/get';

class PrivateRoute extends Component {
  
  render() {
    const { component: Component, currentUser, appLoading, isAdmin, signup, ...rest } = this.props
    
    if (appLoading === true)
      return null
    else{
      return (
        <Route {...rest} render={(props) => {
          const next = get(props, 'location.pathname');
          return (!!currentUser && (!isAdmin || (isAdmin === true && currentUser.is_admin === true)) 
            ? <Component {...props} />
            : <Redirect to={`/${signup === true ? 'signup' : 'login'}${next && next !== '/' ? '?next=' + next : ''}`} state={{from: props.location}} />
        )}} />
      )
    }
  }
}
const mapStateToProps = state => ({ currentUser: currentUserSelector(state), appLoading: (state.app && state.loaders.app) });

export default connect(mapStateToProps)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/components/helpers/router/PrivateRoute.js